import * as moment from 'moment';
import { Comune } from './comune';
import { Incarico } from './incarico';
import { Model } from './model';

export class ModuloContatto extends Model {
  static apiUrl: string = "moduli_contatto";


  data_contatto: moment.Moment;

  nominativo: string;

  ruolo: string;

  tel: string;

  data_fissata_sopralluogo: moment.Moment;

  indirizzo: string;

  comune: Comune;

  motivazione_ritardo_sopralluogo: string;

  recapiti_e_orari: string;

  videoperizia_fattibile: boolean;

  riparazione_proponibile: boolean;

  incarico: Incarico;

  deserialize(input: any): ModuloContatto {
    let retV: ModuloContatto = new ModuloContatto();

    retV = super.deserialize(input) as ModuloContatto;

    if (input?.incarico) {
      retV.incarico = new Incarico().deserialize(input.incarico);
    }

    if (input?.comune) {
      retV.comune = new Comune().deserialize(input.comune);
    }

    if (input?.data_contatto)
      retV.data_contatto = moment(input.data_contatto)

    if (input?.data_fissata_sopralluogo)
      retV.data_fissata_sopralluogo = moment(input.data_fissata_sopralluogo)


    return retV;
  }

  public getHumanIdentifier() {
    return this.incarico?.humanIdentifier;
  }

}
